import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-approve-dialog-component',
  templateUrl: './approve-dialog.component.html',
  styleUrls: ['./approve-dialog.component.scss'],
})
export class ApproveDialogComponent {
  public constructor(private dialogRef: NbDialogRef<ApproveDialogComponent>) {}

  public onApprove(): void {
    this.dialogRef.close(true);
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}
